<template>
    <div class="qty-input">
        <button
            @click="subtract"
            class="button-link qty-input__button subtract"
            type="button"
        >
            -
        </button>
        <input
            v-model="inputValue"
            type="number"
            :name="name"
            :min="min"
            :max="max"
            :id="id"
            v-bind="$attrs"
            class="qty-input__field"
        >
        <button
            @click="add"
            class="button-link qty-input__button add"
            type="button"
        >
            +
        </button>
    </div>
</template>

<script>
    export default {
        name: 'qtyInput',
        data() {
            return {
                inputValue: 0,
            };
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
            id: {
                type: String,
                required: true,
            },
            min: {
                type: String,
                required: false,
                default: 1,
            },
            step: {
                type: String,
                required: false,
                default: 1,
            },
            max: {
                type: String,
                required: false,
                default: null,
            },
        },
        mounted() {
            if (parseFloat(this.value) === 0) {
                this.inputValue = parseFloat(this.value) + parseFloat(this.min);
            } else {
                this.inputValue = parseFloat(this.value);
            }
        },
        methods: {
            subtract() {
                console.log(this.inputValue > parseFloat(this.min));
                if (this.inputValue > parseFloat(this.min)) {
                    this.inputValue -= parseFloat(this.step);
                }
            },

            add() {
                if (!this.max) {
                    this.inputValue += parseFloat(this.step);
                }
                if (this.max && this.inputValue < parseFloat(this.max)) {
                    this.inputValue += parseFloat(this.step);
                }
            },
        },
    };
</script>

<style lang="scss">
    .qty-input {
        display: inline-flex;
        align-items: center;
        height: 60px;
        padding: 0 10px;
        margin-right: 20px;
        background: $thunder;

        &__button.button-link {
            align-items: center;
            justify-content: center;
            width: 15px;
            height: 51px;
            padding: 0;
            font-size: 24px;
            line-height: 1;
            color: $brilliant-rose;
            background: none;
            border: 0;

            &.subtract {
                margin-top: -3px;
            }

            &:focus {
                outline: none;
            }
        }

        &__field {
            flex: 1 0 70px;
            max-width: 70px;
            height: 51px;
            font-family: $font-family;
            font-size: 16px;
            color: #fff;
            text-align: center;
            text-indent: 10px;
            background: none;
            border: 0;
            border-radius: 0;
            box-shadow: none;

            &:focus {
                outline: none;
            }
        }
    }
</style>
